<template>
    <v-container>
        <div class="recipeBox">
            <v-layout row wrap>
                <v-flex text-xs-center xs3 style="margin:auto;">{{recipeName}}</v-flex>
                <v-flex text-xs-center v-bind:style="[maxQuantity > 0 ? {'color':'green'}:{'color':'white'}]" xs3 style="margin:auto;">Maximum: {{maxQuantity}}</v-flex>
                <v-flex xs2>
                    <v-slider v-model="slider" thumb-label="always" :max="maxQuantity" min=0></v-slider>
                </v-flex>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
import {
    recipeList,
    findMaxKits
} from '../../helpers/transmutationManager.js'

export default {
    name: 'recipeElement',
    props: [
        'recipeName',
        'recipeDescription',
        'stocklist',
        'warehouseName'
    ],
    data() {
        return {
            slider:0
        }
    },
    computed: {
        maxQuantity: function(props) {
            let recipe = recipeList.find(recipeItem => {
                return (recipeItem.name == props.recipeName)
            })
            return findMaxKits(
                props.stocklist,
                props.warehouseName,
                recipe)
        }
    },
    watch:{
        slider:function(quantityToMake){
            const event = {recipe:this.recipeName,value:this.slider};
            this.$emit('sliderChange',event)
        }
    },
}
</script>

<style scoped>
    .recipeBox {
        height: 70px;
        width: 40vw;
        border: 4px gray inset;
        border-radius: 4px;
        padding: 0px 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/stockTransmutation/recipeElement.vue